import React, { FC } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Typography,
} from "@mui/material";
import styled from "@emotion/styled";
import editIcon from "../../../assets/images/actionIcon/edit.png";
import deleteIcon from "../../../assets/delete.png";

interface CustomTableCellProps {
  width: string;
}

const CustomTableCell = styled(TableCell)<CustomTableCellProps>(
  ({ width }) => ({
    border: "0px solid #dbdbdb",
    padding: "4px 16px",
    width: width,
  }),
);

const FirstColumnTableCell = styled(CustomTableCell)({
  backgroundColor: "#eeecef",
  fontWeight: 600,
});

interface ModulePermissions {
  module_name: string;
  permissions: string[];
}

interface RolePermissions {
  role: string;
  modules: ModulePermissions[];
}

interface PermissionsTableProps {
  permissions?: RolePermissions[];
  onClickEdit: (rolePermission: RolePermissions) => void;
  onClickDelete: (rolePermission: RolePermissions) => void;
  handlePermissionChange?: (
    e: React.ChangeEvent<HTMLInputElement>,
    role: string,
    moduleName: string,
    permissionType: string,
  ) => void;
}

const PermissionsTable: FC<PermissionsTableProps> = ({
  permissions,
  handlePermissionChange,
  onClickEdit,
  onClickDelete,
}) => {
  return (
    <>
      <TableContainer sx={{ marginBottom: "16px" }} component={Paper}>
        {permissions ? (
          permissions?.map((rolePermission) => (
            <Table
              key={rolePermission.role}
              sx={{ border: "3px solid #dbdbdb", marginBottom: "16px" }}
            >
              <TableHead>
                <TableRow>
                  <FirstColumnTableCell width="" colSpan={5}>
                    Role: {rolePermission.role}
                    <span
                      style={{
                        cursor: "pointer",
                        display: ["admin", "Admin", "Owner"].includes(
                          rolePermission.role,
                        )
                          ? "none"
                          : "inline-block",
                      }}
                    >
                      <img
                        src={editIcon}
                        alt="logo"
                        style={{ width: "20px", margin: "0px 10px" }}
                        onClick={() => {
                          if (
                            !["Admin", "Owner"].includes(rolePermission.role)
                            // &&
                            // rolePermission.role !== "surveyor"
                          ) {
                            onClickEdit(rolePermission);
                          }
                        }}
                      />
                    </span>
                    <span
                      style={{
                        cursor: "pointer",
                        display: ["admin", "Admin", "Owner","Surveyor"].includes(
                          rolePermission.role,
                        )
                          ? "none"
                          : "inline-block",
                      }}
                    >
                      <img
                        src={deleteIcon}
                        alt="logo"
                        style={{ width: "20px", margin: "0px 4px" }}
                        onClick={() => {
                          if (
                            !["Admin", "Owner"].includes(rolePermission.role)
                            // &&
                            // rolePermission.role !== "surveyor"
                          ) {
                            onClickDelete(rolePermission);
                          }
                        }}
                      />
                    </span>
                  </FirstColumnTableCell>
                </TableRow>
                <TableRow>
                  <FirstColumnTableCell width="30%">
                    Module
                  </FirstColumnTableCell>
                  <CustomTableCell width="17.5%" align="center">
                    Create
                  </CustomTableCell>
                  <CustomTableCell width="17.5%" align="center">
                    Read
                  </CustomTableCell>
                  <CustomTableCell width="17.5%" align="center">
                    Update
                  </CustomTableCell>
                  <CustomTableCell width="17.5%" align="center">
                    Delete
                  </CustomTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rolePermission.modules.map((module) => (
                  <TableRow key={module.module_name}>
                    <FirstColumnTableCell width="30%">
                      {module.module_name.replace(/:/g, ": ")}
                    </FirstColumnTableCell>
                    {["create", "read", "update", "delete"].map(
                      (permissionType) => (
                        <CustomTableCell
                          width="17.5%"
                          align="center"
                          key={permissionType}
                        >
                          {/* <Toggle
                        checked={module.permissions.includes(permissionType)}
                        onChange={(e) =>
                          handlePermissionChange &&
                          handlePermissionChange(
                            e,
                            rolePermission.role,
                            module.module_name,
                            permissionType
                          )
                        }
                        name={`${module.module_name}-${permissionType}`}
                      /> */}
                          <Checkbox
                            sx={{ padding: "0px" }}
                            checked={module.permissions.includes(
                              permissionType,
                            )}
                            // onChange={(e) =>
                            //   handlePermissionChange &&
                            //   handlePermissionChange(
                            //     e,
                            //     rolePermission.role,
                            //     module.module_name,
                            //     permissionType
                            //   )
                            // }
                            name={`${module.module_name}-${permissionType}`}
                          />
                        </CustomTableCell>
                      ),
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ))
        ) : (
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            No Roles Found.
          </Typography>
        )}
      </TableContainer>
    </>
  );
};

export default PermissionsTable;
